import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PROJECTION } from 'constants/ApiConstants';
import { INTERVENTION_PATHS_BY_TYPE, PATH } from 'constants/RoutesConstants';
import { createDictionary } from 'utils/ObjectUtils';

export const NAME_MAX_LENGTH = 60;

export const SHORT_NAME_MAX_LENGTH = 20;

export const DEFAULT_DEALERS_FIELDS =
  'id,name,group,group.data,group.name,status,contractProperties,contractProperties.contractCode';

// On those pages, the selected dealer can not be null so we must check
export const CHECK_INIT_DEALER_PAGES = [
  PATH.CHAT,
  PATH.LEADS,
  PATH.AUDITS,
  PATH.DEVICES,
  PATH.FOLLOW_UP,
  PATH.PAYMENT,
  PATH.CUSTOMERS,
  PATH.REMINDERS,
  PATH.WHITELIST,
  PATH.CHECKLISTS,
  PATH.SAFE_CONFIG,
  PATH.USER_GROUPS,
  PATH.AUDIT_MODELS,
  PATH.GROUP_MANAGEMENT,
  PATH.PARTS_REMINDER,
  PATH.DEALER_EXTRA_DETAILED,
  PATH.KIOSKS_DETAILS,
  PATH.STEPS_DASHBOARD,
  PATH.STEPS_DETAILS,
  PATH.OFFERS_DETAILED,
  PATH.OFFERS_DASHBOARD,
  PATH.CAMPAIGNS_DETAILS,
  PATH.DEALER_MANAGEMENT,
  PATH.CAMPAIGNS_DASHBOARD,
  PATH.GUIDELINE_DETAILED,
  PATH.CHECKLISTS_DETAILED,
  PATH.SELF_SERVICE_MOBILITY,
  PATH.MEDIA_LIBRARY_GROUP,
  PATH.GUIDELINES_DASHBOARD,
  PATH.MEDIA_LIBRARY_DEALER,
  PATH.CONTACT_LISTS_DETAILS,
  PATH.AUDIT_MODELS_DETAILED,
  PATH.DEALER_EXTRA_DASHBOARD,
  PATH.CONTACT_LISTS_DASHBOARD,
  PATH.QUESTION_MODEL_DETAILED,
  PATH.KEY_DROP_OFF_APPOINTMENTS,
  PATH.DEALER_CONFIG_SCREENSAVERS,
  PATH.CONFIGURATOR_OFFERS_DETAILED,
  PATH.KEY_DROP_OFF_LOCKER_PLANNING,
  PATH.PREDEFINED_MESSAGES_DETAILED,
  PATH.VEHICLE_CHECK_MODEL_DETAILED,
  PATH.PREDEFINED_MESSAGES_DASHBOARD,
  PATH.DEALER_QUESTION_MODEL_DASHBOARD,
  PATH.DEALER_CONFIG_SCREENSAVER_DETAILS,
  PATH.GATE_MANAGEMENT_DETAILS,
  PATH.SELF_SERVICE_KANBAN,
  PATH.CAMERAS,
  PATH.CAMERAS_DETAILS,
  PATH.PAYERS,
  PATH.PAYERS_DETAILS,
  PATH.STATS_ODITOO,
  PATH.DEALER_CONFIG_SCREENSAVERS,
  PATH.DEALER_TAGS_DETAILS,
  PATH.DEALER_TAGS_DASHBOARD,
  PATH.DEALER_CCM,
];

// Disabled auto select for those pages
export const SKIP_INIT_DEALER_PAGES = [
  PATH.DEALERS_DETAILS,
  PATH.GROUP_CONFIG_PAGE,
  PATH.DEALER_CONFIG_PAGE,
  PATH.KEY_DROP_OFF_LOCKER_DETAILED,
  PATH.KEY_DROP_OFF_APPOINTMENTS_DETAILED,
  ...Object.values(INTERVENTION_PATHS_BY_TYPE).flat()
];

export const OVERRIDE_PROJECTION_FOR_PAGES = createDictionary({
  [PATH.STEPS_DASHBOARD.path]: PROJECTION.CONFIG,
  [PATH.STEPS_DETAILS.path]: PROJECTION.CONFIG,
  [PATH.AUDIT_MODELS.path]: PROJECTION.CONFIG,
}, PROJECTION.DETAILS);

export const SMALL_DISTANCE_UNIT = {
  MM: 'MM',
  IN_1_32: 'IN_1_32',
};

export const LARGE_DISTANCE_UNIT = {
  KM: 'KM',
  MI: 'MI',
};

export const DEFAULT_DISTANCE_UNIT = {
  smallDistanceUnit: SMALL_DISTANCE_UNIT.MM,
  largeDistanceUnit: LARGE_DISTANCE_UNIT.KM,
};

export const DISTANCE_UNIT_LABEL = {
  [SMALL_DISTANCE_UNIT.MM]: <FormattedMessage id="global.unit.MM" defaultMessage="Millimeters (mm)" />,
  [SMALL_DISTANCE_UNIT.IN_1_32]: <FormattedMessage id="global.unit.IN_1_32" defaultMessage='Inches (/32")' />,
  [LARGE_DISTANCE_UNIT.KM]: <FormattedMessage id="global.unit.KM" defaultMessage="Kilometers (km)" />,
  [LARGE_DISTANCE_UNIT.MI]: <FormattedMessage id="global.unit.MI" defaultMessage="Miles (mi)" />,
};

export const ISO_DISTANCE_UNIT = {
  [SMALL_DISTANCE_UNIT.MM]: <FormattedMessage id="mm" defaultMessage="mm" />,
  [SMALL_DISTANCE_UNIT.IN_1_32]: <FormattedMessage id="in_1_32" defaultMessage='/32"' />,
  [LARGE_DISTANCE_UNIT.KM]: <FormattedMessage id="km" defaultMessage="km" />,
  [LARGE_DISTANCE_UNIT.MI]: <FormattedMessage id="mi" defaultMessage="mi" />,
};

export const getDistanceOptions = distanceEnum =>
  Object.values(distanceEnum).map(distance => ({
    value: distance,
    label: DISTANCE_UNIT_LABEL[distance],
  }));

export const SCHEDULERS_MIN_LENGTH = 1;

export const SCHEDULERS_MAX_LENGTH = 10;

export const MONITORING_ITEMS_MIN_LENGTH = 1;

export const MONITORING_ITEMS_MAX_LENGTH = 10;

export const MONITORING_DELAY_MIN_IN_MINUTES = 1;

export const MONITORING_DELAY_MAX_IN_MINUTES = 360;
